import React from 'react'
import UsePagination from '../../../../hooks/UsePagination'
import { MDBBtn, MDBCol, MDBPageItem, MDBPageNav, MDBPagination, MDBRow } from 'mdbreact'
import { NumericFormat } from 'react-number-format';
const ProductoCard = ({ ruta, ...props }) => {
    const imagenes = JSON.parse(props.url_imagen)[0]

    return (
        <MDBCol md="4 ">
            <div className='producto-componente '>
                <img
                    className="card-img-top"
                    src={ruta + 'productos/' + imagenes.nombre_imagen}
                    alt="First slide"
                />

                <h5 className="card-title">{props.nombre_producto}</h5>
                <NumericFormat className="card-text" displayType="text" value={props.precio_producto} prefix={'$'} />

                <MDBBtn color="purple" rounded>Añadir al carrito</MDBBtn>
            </div>
        </MDBCol>

    )
}

const Productos = ({ productos, ruta }) => {
    const { items } = UsePagination(productos)
    const handlePageClick = (event) => {

        console.log(
            event,
            `User requested page number which is offset `
        );
    };
    return (
        <>
            <MDBRow>
                {items && items.map(producto => <ProductoCard {...producto} ruta={ruta} key={producto.id} />)}
            </MDBRow>
            <hr />
            <MDBPagination color="dark">
                <MDBPageItem active >
                    <MDBPageNav >
                        1 <span className="sr-only">(current)</span>
                    </MDBPageNav>
                </MDBPageItem>
                <MDBPageItem >
                    <MDBPageNav>
                        2
                    </MDBPageNav>
                </MDBPageItem>
                <MDBPageItem>
                    <MDBPageNav>
                        3
                    </MDBPageNav>
                </MDBPageItem>
                <MDBPageItem>
                    <MDBPageNav>
                        4
                    </MDBPageNav>
                </MDBPageItem>
                <MDBPageItem>
                    <MDBPageNav>
                        5
                    </MDBPageNav>
                </MDBPageItem>
                <MDBPageItem>
                    <MDBPageNav>
                        <span>{'>'}</span>
                    </MDBPageNav>
                </MDBPageItem>
            </MDBPagination>
        </>
    )
}

export default Productos